import React, { useState } from 'react';
import { Button, Form, Input, Modal, Space, Spin } from 'antd';
import { EditOutlined, DeleteOutlined, EyeOutlined } from '@ant-design/icons';
import { deleteCustomer, exportToCSV, getUsersList } from '../../store/slices/userSlice';
import TableComponent from '../../components/TableComponent';
import { useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';
import { getSubAdmins } from '../../store/slices/roleSlice';

const SubAdminList = () => {
    const navigate = useNavigate();
    const [exportData, setExportData] = useState([])
    const columns = [
        {
            title: 'First Name',
            dataIndex: 'first_name',
            key: 'first_name',
        },
        {
            title: 'Last Name',
            dataIndex: 'last_name',
            key: 'last_name',
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
        },
        {
            title: 'Phone',
            dataIndex: 'phone',
            key: 'phone',
        },
        {
            title: 'Created At',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render : (_, data) => {
                if (data?.createdAt) {
                    const date = new Date(data?.createdAt);
                    return date.toLocaleDateString('en-CA')
                }
            }
        },
        {
            title: 'Role',
            dataIndex: 'role',
            key: 'role',
            render : (_, data) => {
                return data?.role?.name
            }
        },
        {
            title: 'Block/UnBlock',
            dataIndex: 'is_verified',
            key: 'is_verified',
            render: (_, data) => {
                if (data?.is_verified == 1) {
                    return 'UnBlock'
                } else if (data?.is_verified == 0) {
                    return 'Block'
                }
            }
        },
        {
            title: 'Actions',
            key: 'actions',
            render: (_, data) => (
                <Space>
                    <Button onClick={() => navigate('/sub_admin/edit/' + data?._id)} icon={<EditOutlined />} size="small">Edit</Button>
                    {/* <Button onClick={() => navigate('/customer/view/' + data?._id)} icon={<EyeOutlined />} size="small">View</Button> */}
                    {/* <Button onClick={() => openCustomerModal(data?._id)} icon={<DeleteOutlined />} size="small" danger>Delete</Button> */}
                </Space>
            ),
        },
    ];

    const searchedData = async (data) => {
        setExportData(data)
    }

    return (
        <div>
            <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h1>Sub Admins</h1>
                <Button type="primary" onClick={() => navigate('/sub_admin/add')}>
                    Add Sub Admin
                </Button>
            </div>
            <TableComponent
                listData={getSubAdmins}
                columns={columns}
                searchedData={searchedData}
                placeholder="Search sub admin..."
                listName="User"
            />
        </div>
    );
};

export default SubAdminList;

